import React, { useContext } from 'react';

import PrebookingAssignmentContext from 'modules/pre-booking/assignment/context';
import {
  StyledCard,
  StyledHeader,
  StyledSidebar,
  StyledContent,
  StyledInfo,
  StyledAssignWrapper,
  StyledCardWrapper,
} from 'modules/assignment-cards/styled';

import { JourneysInfo, PrebookingVehicleInfo } from 'modules/assignment-cards/components';

import HeaderInfo from './HeaderInfo';
import BookingInfo from './BookingInfo';

const PrebookingCard = ({
  id,
  backgroundSkin,
  isFirst,
  vertical,
  assignActionComponent: AssignActionComponent = null,
}) => {
  const { prebookingsObject } = useContext(PrebookingAssignmentContext);

  const prebooking = prebookingsObject[id] || {};

  const { driver = {}, vehicles = [], internal_notes = '', vehicle_type = '' } = prebooking;

  const prebookingVehicleModel = {
    vehicle_type: vehicle_type,
    internal_notes: internal_notes,
  };

  return (
    <StyledCardWrapper backgroundSkin={backgroundSkin} vertical={vertical}>
      <StyledCard data-testid="prebooking_card" isFirst={isFirst} vertical={vertical}>
        <StyledHeader>
          <HeaderInfo id={id} />
        </StyledHeader>
        <StyledSidebar>
          <PrebookingVehicleInfo model={prebookingVehicleModel} />
        </StyledSidebar>
        <StyledInfo>
          <BookingInfo id={id} />
        </StyledInfo>
        <StyledContent vertical={vertical}>
          {!!AssignActionComponent && (
            <StyledAssignWrapper>
              <AssignActionComponent
                driverId={driver?.id}
                vehicleIds={vehicles?.map((v) => v.id)}
                prebookingId={prebooking?.id}
              />
            </StyledAssignWrapper>
          )}
          <JourneysInfo id={id} journeys={prebooking.journeys} fetching={false} />
        </StyledContent>
      </StyledCard>
    </StyledCardWrapper>
  );
};

export default PrebookingCard;
